import React from 'react';
import { useIntl } from 'react-intl';
import location from 'services/router/location';
import { sendTracking } from 'services/google-analytics';
import Html from 'components/html';
import Button from 'components/button';
import BackgroundImage from 'components/background-image';
import type { ResponsiveImageOutput } from 'contracts';

import tracking from '../success-stories-banner.tracking';
import messages from '../success-stories-banner.i18n';

import styles from './gallery-item.module.scss';

interface GalleryItemElement {
  image: ResponsiveImageOutput;
  name: string;
  quote: string;
  link: string;
}

const GalleryItem: React.FunctionComponent<GalleryItemElement> = (props) => {
  const { formatMessage } = useIntl();
  const translation = messages.pages.landing.successStoriesBanner.livejasmin;
  const { image, name, quote, link } = props;

  const handleWatchInterviewClick = React.useCallback(() => {
    sendTracking(tracking.watchInterview, { name });
    location.navigate(link, '_blank');
  }, [link, name]);

  return (
    <Html.div className={[styles.galleryItem, 'me-3']}>
      <BackgroundImage className={['w-100 h-100', styles.image]} src={image} />
      <Html.div className={['w-100 pt-19 pb-4 px-4', styles.infoMobile]}>
        <Html.div className={['mb-2', styles.name]}>{name}</Html.div>
        <Html.div className={styles.link}>
          <Button variant="text-primary" size="s" onClick={handleWatchInterviewClick}>
            {formatMessage(translation.watchInterview)}
          </Button>
        </Html.div>
      </Html.div>
      <Html.div className={['w-100 pb-4 px-4 d-none d-md-block', styles.infoDesktop]}>
        <Html.header className={['mb-1', styles.name]}>{name}</Html.header>
        <Html.p className={['mb-4', styles.quote]}>{quote}</Html.p>
        <Html.div className={styles.link}>
          <Button variant="text-primary" size="s" onClick={handleWatchInterviewClick}>
            {formatMessage(translation.watchInterview)}
          </Button>
        </Html.div>
      </Html.div>
    </Html.div>
  );
};

export default GalleryItem;
